import { createApi } from '@reduxjs/toolkit/query/react';
import { getVideoTokenForEachCandidate } from '$store/modules/candidates-video-token/queries/getVideoTokenForEachCandidate.query';

import { ReducerPaths } from '../../constants/reducerPaths';
import { baseQuery } from '../../utils/baseQuery';

export const candidatesVideoTokenApi = createApi({
  reducerPath: ReducerPaths.CANDIDATES_VIDEO_TOKEN,
  baseQuery,
  // keepUnusedDataFor: 240,
  refetchOnMountOrArgChange: 30,
  refetchOnReconnect: true,
  tagTypes: ['CandidatesVideoToken'],
  endpoints: (builder) => ({
    getVideoTokenForEachCandidate: getVideoTokenForEachCandidate(builder),
  }),
});

export const { useLazyGetVideoTokenForEachCandidateQuery } =
  candidatesVideoTokenApi;
